// Wrapper fetch maison. credentials: include, X-HTTP-Method-Override pour PUT/DELETE.

const BASE = '/api';

export class ErreurApi extends Error {
  constructor(message, statut, donnees) {
    super(message);
    this.name = 'ErreurApi';
    this.statut = statut;
    this.donnees = donnees;
  }
}

async function lireJsonOuTexte(reponse) {
  const texte = await reponse.text();
  if (!texte) return null;
  try { return JSON.parse(texte); } catch { return texte; }
}
function lancerSiErreur(reponse, donnees) {
  if (!reponse.ok) {
    const msg = (donnees && typeof donnees === 'object' && donnees.erreur)
      || reponse.statusText || `Erreur HTTP ${reponse.status}`;
    throw new ErreurApi(msg, reponse.status, donnees);
  }
}

async function requete(methode, chemin, corps) {
  const methodeReseau = ['PUT', 'DELETE', 'PATCH'].includes(methode) ? 'POST' : methode;
  const headers = {};
  if (corps) headers['Content-Type'] = 'application/json';
  if (methodeReseau !== methode) headers['X-HTTP-Method-Override'] = methode;
  const reponse = await fetch(BASE + chemin, {
    method: methodeReseau, credentials: 'include', headers,
    body: corps ? JSON.stringify(corps) : undefined,
  });
  const donnees = await lireJsonOuTexte(reponse);
  lancerSiErreur(reponse, donnees);
  return donnees;
}
async function postFormData(chemin, formData) {
  const reponse = await fetch(BASE + chemin, {
    method: 'POST', credentials: 'include', body: formData,
  });
  const donnees = await lireJsonOuTexte(reponse);
  lancerSiErreur(reponse, donnees);
  return donnees;
}

export const api = {
  get:    (c)    => requete('GET',    c),
  post:   (c, b) => requete('POST',   c, b),
  put:    (c, b) => requete('PUT',    c, b),
  delete: (c, b) => requete('DELETE', c, b),
  postFormData,
};
